export const serviceConfigModel = `
  summaryEnabled
  summaryRequired
  prescriptionsEnabled
  providerSelectionType
  fileUploadsEnabled
  queueType
  queueEnforcementType
  forceCloseAppointmentEnabled
  schedulingType
  fixedAppointmentDuration
  defaultAppointmentDuration
  maxAppointmentDuration
  cancelReasonRequired
`;
